import React from "react";
import { useRouteError } from "react-router-dom";
import { FaExclamationTriangle } from "react-icons/fa";

export default function ErrorPage() {
  const error: any = useRouteError();

  return (
    <div className="flex flex-col items-center justify-center px-4 pt-8">
      <div className="bg-white rounded-2xl p-8 max-w-md w-full text-center border border-gray-200">
        <div className="flex justify-center mb-4">
          <FaExclamationTriangle className="text-red-500 w-12 h-12" />
        </div>
        <h1 className="text-2xl font-semibold text-gray-800 mb-2">
          Oops! Something went wrong
        </h1>
        <p className="text-gray-600 mb-6">
          {error?.statusText ||
            error?.message ||
            "An unexpected error occurred."}
        </p>

        <div className="flex flex-col sm:flex-row justify-center gap-3">
          <button
            onClick={() => window.location.reload()}
            className="px-5 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition"
          >
            Refresh Page
          </button>

          <button
            onClick={() => (window.location.href = "/")}
            className="px-5 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition"
          >
            Go Home
          </button>
        </div>
      </div>

      <p className="text-gray-400 text-sm mt-6">
        &copy; {new Date().getFullYear()} ProtectAll. All rights reserved.
      </p>
    </div>
  );
}
